import React from "react";
import { Grid, Box } from "@material-ui/core";
import PropTypes from "prop-types";
import { countryListWithoutVIUS as countryList } from "util/icwUtility";
import Creatable from "react-select/creatable";
import Select from "react-select";
import T from "i18n-react";

const SupplierForm = props => {
    const { cert, country, certList, handleCertChange, handleCountryChange, disabled } = props;

    return (
        <>
            <Box display="flex" justifyContent="flex-start" pt={4} pb={2}>
                <Box fontSize="16px" fontWeight="bold" color="#232B3A">
                    {T.translate("iSource.form.subtitle1")}
                </Box>
            </Box>
            <Grid container justify="flex-start" spacing={2}>
                <Grid item xs={12} sm={12} md={6}>
                    <Box fontSize="12px" fontWeight="400">
                        {T.translate("iSource.form.cert")}
                    </Box>
                    <Creatable
                        styles={{
                            control: base => ({
                                ...base,
                                backgroundColor: "transparent",
                                "&:hover": {
                                    borderColor: '#0C91C4',
                                }
                            }),
                        }}
                        options={certList}
                        value={cert}
                        onChange={handleCertChange}
                        isClearable
                        placeholder={T.translate("iSource.placeholder.cert")}
                        isDisabled={disabled}
                    />
                </Grid>
            </Grid>
            <Grid container justify="flex-start" spacing={2}>
                <Grid item xs={12} sm={12} md={6}>
                    <Box fontSize="12px" fontWeight="400">
                        {T.translate("iSource.form.location")}
                    </Box>
                    <Select
                        name="country"
                        styles={{
                            control: base => ({
                                ...base,
                                backgroundColor: "transparent",
                                "&:hover": {
                                    borderColor: '#0C91C4',
                                }
                            }),
                        }}
                        options={countryList.map(rec => ({
                            label: T.translate(`country.${rec.region}`),
                            value: rec.region,
                        }))}
                        value={country}
                        onChange={handleCountryChange}
                        isClearable
                        placeholder={T.translate("iSource.placeholder.location")}
                        isDisabled={disabled}
                    />
                </Grid>
            </Grid>
        </>
    );
};

SupplierForm.propTypes = {
    classes: PropTypes.object,
    cert: PropTypes.object,
    country: PropTypes.object,
    certList: PropTypes.array,
    handleCertChange: PropTypes.func,
    handleCountryChange: PropTypes.func,
};

export default SupplierForm;
